import Logger from './Logger';

export = Logger;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/index.ts